// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__1WRIh","info":"PatientInfo_info__22n5C"};